import React, { useState, useEffect, useCallback } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import './Auth.css';



const Login = () => {

  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');

  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false);

  const { login, signInWithGoogle } = useAuth();

  const navigate = useNavigate();



  const handleGoogleSignIn = useCallback(async (response) => {

    try {

      // Decode the JWT token to get user info

      const payload = JSON.parse(atob(response.credential.split('.')[1]));

      

      const result = await signInWithGoogle({

        email: payload.email,

        name: payload.name,

        picture: payload.picture,

      });



      if (result.success) {

        navigate('/');

      } else {

        setError(result.error || 'Google sign-in failed');

      }

    } catch (error) {

      setError('Failed to sign in with Google');

      console.error('Google sign-in error:', error);

    }

  }, [signInWithGoogle, navigate]);



  // Load Google Identity Services

  useEffect(() => {

    const loadGoogleScript = () => {

      if (window.google) return;



      const script = document.createElement('script');

      script.src = 'https://accounts.google.com/gsi/client';

      script.async = true;

      script.defer = true;

      script.onload = initializeGoogleSignIn;

      document.body.appendChild(script);

    };



    const initializeGoogleSignIn = () => {

      console.log('🔧 Initializing Google Sign-In with Client ID:', process.env.REACT_APP_GOOGLE_CLIENT_ID);

      

      if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {

        console.error('❌ Google Client ID not found in environment variables');

        return;

      }



      window.google.accounts.id.initialize({

        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,

        callback: handleGoogleSignIn,

        auto_select: false,

        cancel_on_tap_outside: true,

      });



      // Render the Google Sign-In button

      window.google.accounts.id.renderButton(

        document.getElementById('google-signin-button'),

        {

          theme: 'outline',

          size: 'large',

          text: 'signin_with',

          shape: 'pill',

          logo_alignment: 'left',

          width: '100%'

        }

      );

    };



    loadGoogleScript();

  }, [handleGoogleSignIn]);



  const handleSubmit = async (e) => {

    e.preventDefault();

    setError('');

    setLoading(true);



    const result = await login(email, password);

    

    if (result.success) {

      navigate('/');

    } else {

      setError(result.error || 'Failed to login. Please check your credentials.');

    }

    

    setLoading(false);

  };



  return (

    <div className="auth-container">

      <div className="auth-card">

        <div className="auth-header">

          <img src="/logo.png" alt="OMNI" className="auth-logo-img" />

          <h2 className="auth-title">Welcome Back</h2>

          <p className="auth-subtitle">Sign in to manage your digital business cards</p>

        </div>



        {error && <div className="error-message">{error}</div>}



        <form onSubmit={handleSubmit} className="auth-form">

          <div className="form-group">

            <label className="form-label">Email Address</label>

            <input

              type="email"

              className="form-input"

              placeholder="you@example.com"

              value={email}

              onChange={(e) => setEmail(e.target.value)}

              required

            />

          </div>



          <div className="form-group">

            <label className="form-label">Password</label>

            <input

              type="password"

              className="form-input"

              placeholder="Enter your password"

              value={password}

              onChange={(e) => setPassword(e.target.value)}

              required

            />

          </div>



          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>

            {loading ? 'Signing in...' : 'Sign In'}

          </button>

        </form>



        <div className="auth-divider">

          <span>OR</span>

        </div>



        <div className="google-signin-container">

          <div id="google-signin-button"></div>

        </div>



        <div className="auth-footer">

          <p>Don't have an account? <Link to="/register" className="auth-link">Sign Up</Link></p>

        </div>

      </div>

    </div>

  );

};



export default Login;

